import React from 'react';
import { useStore } from 'effector-react';
import { TemplateId } from '@types';
import { $templateId } from '@stores/dataStores';
import TFree from './TFree';
import TVip from './TVip';
import TRealEstateA from './TEstateA';
import TSimple from './TSimple';
import { TMetaA } from './TMetaA';
import TRealEstateB from './TEstateB/TRealEstateB';
import TLegacy from './TLegacy/TLegacy';
import { TProject } from './TProject';

function TemplateWidgets() {
  const templateId = useStore($templateId);
  switch (templateId) {
    case TemplateId.free:
      return <TFree />;
    case TemplateId.vip:
      return <TVip />;
    case TemplateId.simple:
      return <TSimple />;
    case TemplateId.realEstateA:
      return <TRealEstateA />;
    case TemplateId.metaverseA:
      return <TMetaA />;
    case TemplateId.realEstateB:
      return <TRealEstateB />;
    case TemplateId.legacy:
      return <TLegacy />;
    case TemplateId.project:
      return <TProject />;
    default:
      return null;
  }
}

export default TemplateWidgets;
